import Session from '@/utils/Session'
import Toast from '@/utils/toast'
export const layout = {
  namespaced: true,
  state: {
    layout: {
      showBanner: false
    }
  },
  getters: {},
  mutations: {
    setShowBanner(state,bool) {
      console.log(bool,state);
      state.layout.showBanner = bool;
    },
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js